import invariant from 'tiny-invariant';

export { invariant };
